import styled from 'styled-components';

export const Greenhouse = styled.div`
  background: white;
  min-height: 100%;
`
